import React from 'react';
import { skills } from '../data';
import './Skills.css';

const Skills = () => {
  return (
    <section className="skills" id="skills">
      <div className="section-header">
        <div>
          <h2 className="section-title">Technical Skills</h2>
          <p className="section-subtitle">Technologies and frameworks I work with</p>
        </div>
      </div>

      <div className="skills-tags">
        {skills.map((skill, index) => (
          <span 
            key={index} 
            className={`skill-tag ${skill.highlight ? 'highlight' : ''}`}
          >
            {skill.name}
          </span>
        ))}
      </div>
    </section>
  );
};

export default Skills;
